/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import has from"../../../../../core/has.js";function t(t,e){const n=t.extent,o=e?.clone().intersection(n),i=null!=o?o.width*o.height:0,r=e?e.width*e.height:0,h=0===r?0:i/r,s=has("featurelayer-snapshot-point-coverage");return!isNaN(h)&&h>=s}export{t as exceedsMinimumSnapshotCoverage};
